import { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { Form, Button, Card, Spinner, Row, Col, Pagination } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import Sidebar from './sidebar';
import { Plus } from "react-feather";

function ProductSearchPage(){    
  const baseUrl0 = process.env.REACT_APP_BASE_URL_IMG;
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Fetch categories
  useEffect(() => {
    api.get("/categories/")
      .then(res => setCategories(res.data.results))
      .catch(() => {});
  }, []);

  // Fetch products
  const fetchResults = async (pageNum = 1) => {
    try {
      setLoading(true);
      setError(null);

      const params = { page: pageNum };
      if (query.trim()) params.query = query;
      if (category) params.category = category;

      const response = await api.get("/vendor-product-search/", {
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
        params,
      });

      setResults(response.data.results);
      setTotalPages(Math.ceil(response.data.count / 12));
      setPage(pageNum);
    } catch (err) {
      setError("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  // Load products on mount & on filter changes (with debounce)
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchResults(1);
    }, 300);
    return () => clearTimeout(delay);
  }, [query, category]);

  const handleSelect = (templateId) => navigate(`/seller/addproduct?template_id=${templateId}`);
    return (
        <>                     
            <Helmet>
                <title>Quick Add Products Templates</title>
                <meta name="description" content={`Quick Add Products Templates`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max orderscontainer">                               
                            <div className="row mb-4 ph-header-con text-center">
                                <h3 className="pageheader-title mb-2">Quick Add Products</h3>
                                <p className="grey-text lh0 font1">Browse  ready-made product templates. <br/>Or, click <b>'Add Manually'</b> to create a product from scratch.</p>
                            </div>
                            <div className="row mb-3">
                                  <div className="container py-4 mb-6">
                                    <Row className="mb-3 mt-2">
                                      <Col md={6} className="pb-3">
                                        <Form.Control
                                          type="text"
                                          placeholder="Search product template"
                                          value={query}
                                          onChange={(e) => setQuery(e.target.value)}
                                          className="mb-2 h-100"
                                        />
                                      </Col>
                                      <div className="col-6 col-lg-4 pb-3">
                                        <Form.Select className="h-100 mb-2 font9" value={category} onChange={(e) => setCategory(e.target.value)}>
                                          <option value="">All Categories</option>
                                          {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.title}</option>)}
                                        </Form.Select>
                                      </div>
                                      <div className="col-6 col-lg-2 pb-3">
                                        <Link to="/seller/addproduct">
                                          <Button className="w-100 h-100 mb-2 font9"><Plus /> Add Manually</Button>
                                        </Link>
                                      </div>
                                    </Row>

                                    {loading && <Spinner animation="border" className="d-block mx-auto my-4" />}
                                    {error && <p className="text-danger text-center">{error}</p>}

                                    <Row className="g-3">
                                      {results.map(item => (
                                        <Col xs={6} md={4} lg={3} key={item.id}>
                                          <Card className="shadow-sm border pb-2">
                                            {item.images && item.images.length > 0 &&
                                              <Card.Img src={baseUrl0 + item.images[0].image} style={{ height: "180px", objectFit: "cover" }} />
                                            }
                                            <Card.Body>
                                              <Card.Title className="font1 font-bold">{item.title}</Card.Title>
                                              {item.category_name && <Card.Text className="text-muted small">Category: {item.category_name}</Card.Text>}
                                            </Card.Body>
                                            <Card.Footer className="bg-white border-0 pt-0 text-end">
                                              <Button className="w-100 font8" variant="dark" onClick={() => handleSelect(item.id)}>Use Template</Button>
                                            </Card.Footer>
                                          </Card>
                                        </Col>
                                      ))}
                                    </Row>

                                    {!loading && results.length === 0 && (
                                      <p className="text-center text-muted mt-4">
                                        No matching templates available. <Link to={'/seller/addproduct'} className="font-bold"><u>Create a product manually</u></Link>
                                      </p>
                                    )}

                                    {/* Pagination */}
                                    {totalPages > 1 && (
                                      <Pagination className="oscroll mt-4 pb-3">
                                        <Pagination.First onClick={() => fetchResults(1)} disabled={page === 1} />
                                        <Pagination.Prev onClick={() => fetchResults(page - 1)} disabled={page === 1} />
                                        {[...Array(totalPages)].map((_, i) => (
                                          <Pagination.Item key={i} active={page === i + 1} onClick={() => fetchResults(i + 1)}>
                                            {i + 1}
                                          </Pagination.Item>
                                        ))}
                                        <Pagination.Next onClick={() => fetchResults(page + 1)} disabled={page === totalPages} />
                                        <Pagination.Last onClick={() => fetchResults(totalPages)} disabled={page === totalPages} />
                                      </Pagination>
                                    )}
                                  </div>
                            </div>

                    </div>
                </div>

            </section>
        </>
    )
}

export default ProductSearchPage;